import Moment from 'moment'
import { $post } from '@/apis'
const state = () => ({
	checkout: {
		// 国家/地区
		country: 'CN',
		// 	保单额度 购买的商品数量 最小100 50的倍数
		policyAmount: '',
		// 生效开始日期
		effectiveDate: Moment().add(1, 'days').format('YYYY-MM-DD'),
		// 企业名称,示例值(张三)
		enterpriseName: '',
		// 统一社会信用代码
		creditCode: '',
		// 邮箱
		email: '',
		// 手机
		phone: '',
		// 手机验证码
		code: '',
		// 联系人
		contactName: '',
		// 注册地址
		address: '',
		// 预留字段
		policyNoteCode: '',

	}
})
const getters = {}
const mutations = {}
const actions = {
	// 发送验证码
	// scene: 1: 注册, 2: 登录, 3: 找回密码, 4: 年单
	// type: 0: 短信, 1: 语音
	doSendCode(_, { phone, type }) {
		return $post('/admin-api/authz/send-code', {}, { params: { phone, scene: 4, type: type } })
	},
	createOrder(_, form) {
		return $post('/admin-api/guotai/order/create', { ...form, policyAmount: form.policyAmount * 10000 * 100 })
	},
	calcOrderPrice(_, form) {
		return $post('/admin-api/guotai/order/premium/calc', { ...form, policyAmount: form.policyAmount * 10000 * 100 })
	},
	updatePaid(_, requestId) {
		return $post(`/admin-api/guotai/order/payment/status/${requestId}`)
	},
	endorseOrder(_, form) {
		return $post('/admin-api/guotai/order/endorse', {
			...form,
			insuredAmount: form.policyAmount * 10000 * 100
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
